import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';
import submit_n from '../../Common/Images/submit_n.gif';
import cancel_n from '../../Common/Images/cancel_n.gif';
import EL_CompViewEntrants from './EL_CompViewEntrants';
import EL_CompARD from './EL_CompARD';
import EL_CompWinnerDetails from './EL_CompWinnerDetails';
import alert_A_bg from '../../Common/Images/ImagesForAlert/alert_A_bg.png';
import alert_bg from '../../Common/Images/ImagesForAlert/alert_Q_bg_small.png';
import ok_n from '../../Common/Images/ImagesForAlert/ok_n.png';
import ok_o from '../../Common/Images/ImagesForAlert/ok_o.png';
import yes_n from '../../Common/Images/ImagesForAlert/yes_n.png';
import yes_o from '../../Common/Images/ImagesForAlert/yes_o.png';
import no_n from '../../Common/Images/ImagesForAlert/no_n.png';
import no_o from '../../Common/Images/ImagesForAlert/no_o.png';
const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface Competition {
    CompID: number;
    Title: string;
    Type: string;
    Price: number;
    NoOfWinners: number;
    CluePrice: number;
    Answer: string;
    StartDate: string;
    EntryClosesFormatted: string;
    AllocatedTo: string;
    Status: string;
    TotalEntries: number;
    UniqueEntries: number;
    WinnerFlag: string;
    WinnerStatus: string;
}

const EL_ManageComps: React.FC = () => {
    const [comps, setComps] = useState<Competition[]>([]);
    const [countries, setCountries] = useState<string[]>(['All']);
    
    const [showGrid, setShowGrid] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    
    const [filterCountry, setFilterCountry] = useState<string>('All');
    const [filterStatus, setFilterStatus] = useState<string>('All');
    const [filterTitle, setFilterTitle] = useState<string>('');
    
    const [selectedCompId, setSelectedCompId] = useState<number | null>(null);
    const [selectedComp, setSelectedComp] = useState<Competition | null>(null);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [showARD, setShowARD] = useState(false);
    const [showEntrants, setShowEntrants] = useState(false);
    const [showWinnerDetails, setShowWinnerDetails] = useState(false);
    const itemsPerPage = 50; 

    const [alertMsg, setAlertMsg] = useState('');
    const [confirmConfig, setConfirmConfig] = useState<{msg: string, onConfirm: () => void} | null>(null);

    const handleShowWarning = (msg: string) => setAlertMsg(msg);
    
    const handleShowConfirm = (msg: string, onConfirm: () => void) => {
        setConfirmConfig({ msg, onConfirm });
    };

    const handleConfirmYes = () => {
        if (confirmConfig) confirmConfig.onConfirm();
        setConfirmConfig(null);
    };

    useEffect(() => {
        const previousColor = document.body.style.backgroundColor;
        document.body.style.backgroundColor = 'white'; 
        
        fetchCountries();
        return () => {
            document.body.style.backgroundColor = previousColor;
        };
    }, []);

    const fetchCountries = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}api/manage-comps/countries/`);
            if (response.ok) {
                const data = await response.json();
                setCountries(['All', ...data]);
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        setShowGrid(true); 
        setCurrentPage(1); 
        setSelectedCompId(null);
        setSelectedComp(null);

        const params = new URLSearchParams();
        const trimmedTitle = filterTitle.trim();
        params.append('country', filterCountry);
        params.append('status', filterStatus);
        params.append('title', trimmedTitle);

        try {
            const response = await fetch(`${API_BASE_URL}api/manage-comps/?${params.toString()}`);
            if (response.ok) {
                const data = await response.json();
                setComps(data);
            }
        } catch (error) {
            console.error("Error fetching comps:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        window.history.back();
    };

    const handleRowClick = (comp: Competition) => {
        if (selectedCompId !== comp.CompID) {
            setSelectedCompId(comp.CompID);
            setSelectedComp(comp);
        }
    };

    const handleRemove = async () => {
        if (!selectedCompId) return;
        
        handleShowConfirm('Do you want to remove the competition?', async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/manage-comps/${selectedCompId}/`, { method: 'DELETE' });
                if (response.ok) {
                    handleSubmit();
                } else {
                    handleShowWarning("Error deleting competition");
                }
            } catch (e) { 
                console.error(e);
                handleShowWarning("Network error"); 
            }
        });
    };

    const WarningDialog = () => (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 20000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '400px', height: '200px', backgroundImage: `url(${alert_A_bg})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%', position: 'relative', fontFamily: 'Tahoma, Arial, sans-serif', fontSize: '12px', color: 'black' }}>
                <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontWeight: 'bold' }}>Warning</div>
                <div style={{ position: 'absolute', top: '40px', left: '100px', right: '15px', bottom: '50px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <span style={{ fontWeight: 'normal', marginTop: '-25px', fontSize: '11pt' }}>{alertMsg}</span>
                </div>
                <div style={{ position: 'absolute', bottom: '10px', width: '100%', textAlign: 'center' }}>
                    <img src={ok_n} alt="OK" onClick={() => setAlertMsg('')} style={{ cursor: 'pointer' }} onMouseOver={(e) => e.currentTarget.src = ok_o} onMouseOut={(e) => e.currentTarget.src = ok_n} />
                </div>
            </div>
        </div>
    );

    const ConfirmDialog = () => (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 20000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '306px', height: '210px', backgroundImage: `url(${alert_bg})`, backgroundRepeat: 'no-repeat', position: 'relative', fontFamily: 'Tahoma', fontSize: '13px' }}>
                <div style={{ position: 'absolute', top: '5px', left: '0', width: '100%', textAlign: 'center', color: 'white', fontWeight: 'bold', fontSize: '13px' }}>Confirmation</div>
                <div style={{ position: 'absolute', top: '35px', left: '70px', right: '10px', height: '110px', display: 'flex', alignItems: 'center', color: '#525252', fontSize: '11pt' }}>
                    {confirmConfig?.msg}
                </div>
                <div style={{ position: 'absolute', bottom: '15px', width: '100%', textAlign: 'center' }}>
                    <img src={yes_n} alt="Yes" onClick={handleConfirmYes} style={{ cursor: 'pointer', margin: '-10px 15px' }} onMouseOver={(e) => e.currentTarget.src = yes_o} onMouseOut={(e) => e.currentTarget.src = yes_n} />
                    <img src={no_n} alt="No" onClick={() => setConfirmConfig(null)} style={{ cursor: 'pointer', margin: '-10px 15px' }} onMouseOver={(e) => e.currentTarget.src = no_o} onMouseOut={(e) => e.currentTarget.src = no_n} />
                </div>
            </div>
        </div>
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = comps.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(comps.length / itemsPerPage);

    const handleFirstPage = () => {
        setCurrentPage(1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const handleLastPage = () => {
        if (totalPages > 0) setCurrentPage(totalPages);
    };

    const isModifyDisabled = !selectedCompId;
    const isRemoveDisabled = !selectedCompId;
    
    const isWinnerDetailsDisabled = !selectedCompId || selectedComp?.WinnerFlag !== 'Y';
    
    const isViewEntrantsDisabled = !selectedCompId || (selectedComp?.TotalEntries === 0);

    const styles = {
        container: { 
            margin: '3px',
            fontFamily: 'Arial',
            fontSize: '10pt'
        },
        header: { 
            color: 'White', 
            backgroundColor: 'Maroon',
            padding: '5px', 
            fontSize: '12pt',
            fontFamily: 'Arial',
            fontWeight: 'bold' as const,
            textAlign: 'center' as const 
        },
        filterBar: {
            width: '100%',
            backgroundColor: '#F0F8FF',
            border: '1px solid #7F9DB9',
            borderCollapse: 'collapse' as const, 
            marginTop: '2px'
        },
        gridContainer: {
            marginTop: '5px', 
            height: 'calc(100vh - 190px)',
            overflowY: 'auto' as const,
            overflowX: 'auto' as const,
            border: '1px solid #7F9DB9'
        },
        gridHeader: { 
            backgroundColor: '#B5C7DE',
            position: 'sticky' as const, 
            top: 0, 
            fontWeight: 'bold' as const 
        },
        th: { 
            padding: '10px 0px 10px 10px', 
            borderRight: '1px solid #7F9DB9',
            textAlign: 'left' as const, 
            fontSize: '10pt',
            color: '#003399',
            fontWeight: 'normal' as const,
            backgroundColor: '#C7DDFD',
            whiteSpace: 'nowrap' as const,
            minWidth: '100px'
        },
        td: { 
            padding: '8px 0px 8px 10px',
            textAlign: 'left' as const,
            fontSize: '10pt',
            borderRight: '1px solid #7F9DB9',
            whiteSpace: 'nowrap' as const,
            minWidth: '90px'
        },
        footerBtn: { 
            width: '120px', 
            margin: '0 5px', 
            padding: '2px'
        },
        pagination: {
            backgroundColor: '#C7DDFD', 
            padding: '10px',
            textAlign: 'center' as const, 
            fontSize: '10pt', 
            color: 'blue'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                My Incentives Manager Comps
            </div>

            <table style={styles.filterBar} cellPadding={5}>
                <tbody>
                    <tr>
                        <td align="center" style={{ width: '25%', borderRight: '1px solid black' }}>
                            Country :&nbsp;
                            <select 
                                value={filterCountry} 
                                onChange={(e) => setFilterCountry(e.target.value)} 
                                style={{ width: '60%', cursor: 'pointer' }}
                            >
                                {countries.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </td>

                        <td align="center" style={{ width: '25%', borderRight: '1px solid black' }}>
                            Status :&nbsp;
                            <select 
                                value={filterStatus} 
                                onChange={(e) => setFilterStatus(e.target.value)} 
                                style={{ width: '60%', cursor: 'pointer' }}
                            >
                                <option value="All">All</option>
                                <option value="Ended">Ended</option>
                                <option value="Open">Open</option>
                            </select>
                        </td>

                        <td align="center" style={{ width: '25%', borderRight: '1px solid black' }}>
                            Title Like :&nbsp;
                            <input 
                                type="text" 
                                value={filterTitle} 
                                onChange={(e) => setFilterTitle(e.target.value)} 
                                style={{ width: '60%' }} 
                            />
                        </td>

                        <td align="center" style={{ width: '25%', verticalAlign: 'middle' }}>
                              <img
                                src={submit_n}
                                alt="Submit"
                                onClick={handleSubmit}
                                style={{ marginRight: '15px', height: '25px', width: '80px', cursor: 'pointer' }}
                              />
                              <img
                                src={cancel_n}
                                alt="Cancel"
                                onClick={handleCancel}
                                style={{ height: '25px', width: '80px', cursor: 'pointer' }}
                              />
                        </td>
                    </tr>
                </tbody>
            </table>

            {showGrid && (
                <>
                    <div style={styles.gridContainer}>
                        <table style={{ minWidth: '1200px', width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' }}>
                            <thead style={styles.gridHeader}>
                                <tr>
                                    <th style={{...styles.th, minWidth: '20px', width: '20px', textAlign: 'center'}}>#</th>
                                    <th style={styles.th}>Title</th>
                                    <th style={styles.th}>Type</th>
                                    <th style={styles.th} align="right">Price</th>
                                    <th style={styles.th}>No of winner</th>
                                    <th style={styles.th}>Clue Price</th>
                                    <th style={styles.th}>Answer</th>
                                    <th style={styles.th}>Start Date</th>
                                    <th style={styles.th}>Entry Closes</th>
                                    <th style={styles.th}>Allocated to</th>
                                    <th style={styles.th}>Status</th>
                                    <th style={styles.th}>Total Entries</th>
                                    <th style={styles.th}>Unique Entries</th>
                                    <th style={styles.th}>CompID</th>
                                    <th style={styles.th}>Winner Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <Loading />
                                ) : currentItems.map((row, index) => {
                                    const isLastItem = index === currentItems.length - 1;
                                    const rowNum = indexOfFirstItem + index + 1;
                                    const isSelected = selectedCompId === row.CompID;
                                    const rowStyle = {
                                        backgroundColor: isSelected ? 'orange' : (index % 2 === 0 ? '#F4FAFF' : 'white'),
                                        color: isSelected ? 'white' : 'black',
                                        cursor: 'pointer',
                                        borderBottom: isLastItem ? '1px solid #7F9DB9' : 'transparent'
                                    };

                                    return (
                                        <tr 
                                            key={row.CompID}
                                            onClick={() => handleRowClick(row)}
                                            style={rowStyle}
                                        >
                                            <td style={{...styles.td, minWidth: '20px', width: '20px', textAlign: 'left'}}>{rowNum}</td>
                                            <td style={styles.td}>{row.Title}</td>
                                            <td style={styles.td}>{row.Type}</td>
                                            <td style={styles.td} align="right">{row.Price}</td>
                                            <td style={styles.td}>{row.NoOfWinners}</td>
                                            <td style={styles.td}>{row.CluePrice}</td>
                                            <td style={styles.td}>{row.Answer}</td>
                                            <td style={styles.td}>{row.StartDate}</td>
                                            <td style={styles.td}>{row.EntryClosesFormatted}</td>
                                            <td style={styles.td}>{row.AllocatedTo}</td>
                                            <td style={styles.td}>{row.Status}</td>
                                            <td style={styles.td}>{row.TotalEntries}</td>
                                            <td style={styles.td}>{row.UniqueEntries}</td>
                                            <td style={styles.td}>{row.CompID}</td>
                                            <td style={styles.td} dangerouslySetInnerHTML={{ __html: row.WinnerStatus }}></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div style={styles.pagination}>
                        <span 
                            style={{ 
                                cursor: currentPage === 1 ? 'default' : 'pointer', 
                                marginRight: '10px', 
                                fontWeight: 'bold',
                                color: currentPage === 1 ? 'grey' : 'inherit'
                            }} 
                            onClick={currentPage === 1 ? undefined : handleFirstPage}
                            title="Go to First Page"
                        >
                            &lt;&lt;&nbsp;
                        </span>

                        <span 
                            style={{ 
                                cursor: currentPage === 1 ? 'default' : 'pointer', 
                                marginRight: '5px', 
                                fontWeight: 'bold',
                                color: currentPage === 1 ? 'grey' : 'inherit'
                            }} 
                            onClick={currentPage === 1 ? undefined : handlePrevPage}
                            title="Previous Page"
                        >
                            &lt;&nbsp;
                        </span>
                        
                        <span>
                            {currentPage} of {totalPages === 0 ? 1 : totalPages}
                        </span>&nbsp;

                        <span 
                            style={{ 
                                cursor: (currentPage === totalPages || totalPages === 0) ? 'default' : 'pointer', 
                                marginLeft: '5px', 
                                fontWeight: 'bold',
                                color: (currentPage === totalPages || totalPages === 0) ? 'grey' : 'inherit'
                            }} 
                            onClick={(currentPage === totalPages || totalPages === 0) ? undefined : handleNextPage}
                            title="Next Page"
                        >
                            &gt;&nbsp;
                        </span>

                        <span 
                            style={{ 
                                cursor: (currentPage === totalPages || totalPages === 0) ? 'default' : 'pointer', 
                                marginLeft: '10px', 
                                fontWeight: 'bold',
                                color: (currentPage === totalPages || totalPages === 0) ? 'grey' : 'inherit'
                            }} 
                            onClick={(currentPage === totalPages || totalPages === 0) ? undefined : handleLastPage}
                            title="Go to Last Page"
                        >
                            &gt;&gt;
                        </span>
                    </div>

                    <div style={{ marginTop: '10px', textAlign: 'center', padding: '8px' }}>
                        <button style={styles.footerBtn}
                        onClick={() => { setSelectedCompId(null); setShowARD(true); }}
                        >Add</button>
                        <button 
                            style={styles.footerBtn} 
                            disabled={isModifyDisabled}
                            onClick={() => {
                                if (selectedCompId) setShowARD(true);
                            }}
                        >
                            View/Modify
                        </button>
                        <button 
                            onClick={handleRemove} 
                            style={styles.footerBtn} 
                            disabled={isRemoveDisabled}
                        >
                            Remove
                        </button>
                        <button 
                            style={styles.footerBtn} 
                            disabled={isViewEntrantsDisabled}
                            onClick={() => { if(selectedCompId) setShowEntrants(true); }}
                        >
                            View Entrants
                        </button>
                        <button 
                            style={styles.footerBtn} 
                            disabled={isWinnerDetailsDisabled}
                            onClick={() => { if(selectedCompId) setShowWinnerDetails(true); }}
                        >
                            Winner Details
                        </button>
                    </div>
                </>
            )}
            {showARD && (
                <EL_CompARD 
                    compId={selectedCompId} 
                    onClose={() => setShowARD(false)} 
                    onSaveSuccess={handleSubmit} 
                    showWarning={handleShowWarning}
                    showConfirm={handleShowConfirm}
                />
            )}
            {showEntrants && selectedComp && (
                <EL_CompViewEntrants 
                    comp={selectedComp} 
                    onClose={() => setShowEntrants(false)} 
                />
            )}
            {showWinnerDetails && selectedCompId && (
                <EL_CompWinnerDetails 
                    compId={selectedCompId} 
                    onClose={() => setShowWinnerDetails(false)} 
                />
            )}
            {alertMsg && <WarningDialog />}
            {confirmConfig && <ConfirmDialog />}
        </div>
    );
}

export default EL_ManageComps;